export default "__VITE_ASSET__3affcc90__"